<template>
    <h2 class="page__title">
        <slot></slot>
    </h2>
</template>

<script>
export default {
    name: 'main-title'
}
</script>

<style lang="scss" scoped>
.page {
    &__title {
        width: 95%;
        font-size: 28px;
        margin-bottom: 12px;
        display: flex;

        &_between { 
            justify-content: space-between;
        }

        &_center {
            align-items: center;
        }
    }
}

.action {
    margin-left: 10px;
}
</style>